import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLoader } = FiIcons;

const LoadingSpinner = ({ message = 'Loading...' }) => {
  return (
    <div className="flex flex-col items-center justify-center p-8 text-gray-500">
      <div className="animate-spin mb-3">
        <SafeIcon icon={FiLoader} className="w-8 h-8 text-blue-500" />
      </div>
      <p className="text-sm font-medium">{message}</p>
    </div>
  );
};

export default LoadingSpinner;